<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <div class="container-fluid">
        <div class="card card-details">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-8">
                <span class="d-block title">{{lead.name}}</span>
              </div>
              <div class="col-4 text-right">
                <span class="label-status">{{lead.status_name}}</span>
                 <span class="lead-no mt-2">{{lead.lead_no}}</span>
              </div>

            </div>
            <div class="row">
              <div class="col-12 mb-2" v-if="lead.email">
                <label>Email </label>
                <span class="label-info">{{lead.email}}</span>
              </div>
              <div class="col-12 mb-2" v-if="lead.phone">
                <label>Phone </label>
                <span class="label-info">{{lead.phone}}</span>
              </div>
              <div class="col-12 mb-2">
                <label>Tags </label>
                <span class="label-info">{{lead.tags}}</span>
              </div>
              <div class="col-12 mb-2" v-if="lead.enquiry">
                <label>Enquiry</label>
                <span class="label-info">{{lead.enquiry}}</span>
              </div>
              <div class="col-12 mb-2" v-if="lead.assigned_to">
                <label>Assigned to </label>
                <span class="label-info">{{lead.assigned_to}}</span>
              </div>
              <div class="col-12 mb-2" v-if="deadStatusIds.includes(lead.status_id)">
                <label>Dead Reason </label>
                <span class="label-info">{{lead.dead_reason_name}}</span>
              </div>
              <div class="col-12 mb-2" v-if="lead.budget">
                <label>Budget</label>
                <span class="label-info">{{lead.formatted_budget | asINR}}</span>
              </div>
              <div class="col-12 mb-2" v-if="lead.city_name">
                <label>City</label>
                <span class="label-info">{{lead.city_name}}</span>
              </div>
              <div class="col-12 mb-2" v-if="lead.comments">
                <label>Comments</label>
                <span class="label-info">{{lead.comments}}</span>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-6 ">
                <a
                  class="btn btn-block btn-primary d-block"
                  :href="`tel:${lead.phone}`"
                >
                  <img src="@/assets/phone.svg" class="mb-1 mr-2" />Call</a
                >
              </div>
              <div class="col-6 text-center  mt-1">
                <router-link class="btn btn-primary-outline p-0" :to="{name: 'EditLead', id: $route.params.id}">
                  <img
                    src="@/assets/edit.svg"
                    class="mb-1 mr-2"
                  />Edit</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Broker",
  data() {
    return {
      lead: {},
    };
  },
  created() {
    this.fetchLeadDetail();
  },
  methods: {
    fetchLeadDetail(){
      let uuid = this.$route.params.id;
      this.$axios.get(`leads/${uuid}`).then((res) => {
        this.lead = res.data.lead;
      });
    }
  },
  computed: {
    deadReasons() {
      return this.$store.getters.deadReasons;
    },
    deadStatusIds() {
      return this.$store.getters.deadStatusIds;
    },
  }
};
</script>

